// Кирпичный
// Монолитный
// Панельный

import materialType from './material-type';

export default materialType.filter(mt => ['brick', 'monolith', 'panel'].includes(mt.key));
